import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme?.tmsMenu?.menuBackgroundColor,
    height: '100vh',
  },
  wrapper1: {
    height: '46%',
    padding: theme.spacing(3),
    paddingTop: 0,
  },
  wrapper2: {
    height: '46%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    padding: theme.spacing(3),
  },
  row: {
    display: 'flex',
    padding: theme.spacing(1),
    alignItems: 'center',
    cursor: 'pointer',
    borderRadius: theme.spacing(0.4),
    marginBottom: 2,
    "&:hover": {
      background: 'linear-gradient(to right, #7166F910, #7166F930)',
    }
  },
  menuIcon: {
    color: theme?.tmsMenu?.menuIconColor,
  },
  menuLabel: {
    color: theme?.tmsMenu?.menuLabelColor,
    marginLeft: theme.spacing(2),
  },
  backWrapper: {
    height: '8%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  backIcon: {
    color: theme?.tmsMenu?.backIconColor,
  },
  expandIcon: {
    position: 'absolute',
    right: 0,
  },
  subMenuBgColor: {
    backgroundColor: theme?.tmsMenu?.menuBackgroundColor,
  },
  activeMenuBgColor: {
    background: 'linear-gradient(to right, #7166F910, #7166F930)',
  },
}));

export default useStyles;
